export default __webpack_public_path__ + "images/9203bf56f43a5fdb1611552038e74266.png";